import { render } from "./products.vue?vue&type=template&id=6efead56"
import script from "./products.vue?vue&type=script&lang=js"
export * from "./products.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/vueComponents/admin/products.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6efead56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6efead56', __exports__)) {
    api.reload('6efead56', __exports__)
  }
  
  module.hot.accept("./products.vue?vue&type=template&id=6efead56", () => {
    api.rerender('6efead56', render)
  })

}


export default __exports__